
import promiseErrors from '~/services/promiseErrors';
import paginationMixin from '~/mixins/pagination';

export default {
    name: 'Events',
    mixins: [paginationMixin],
    async asyncData({ app, redirect, route }) {
        const [events, groups] = await promiseErrors(
            [
                app.$axios.$get(app.$config.endpoints.event, { params: { per_page: 9, page: route.query.page || 1 } }),
                app.$axios.$get(app.$config.endpoints.group, { params: { per_page: 3, page: 1 } }),
            ],
            app,
        );

        if (events && events.events.last_page < (route.query.page || 1)) {
            redirect({ name: 'events' });
        }

        return {
            events: events ? events.events.data : [],
            groups: groups ? groups.groups.data : [],
            pagination: {
                current: events ? events.events.current_page : 1,
                total: events ? events.events.last_page : 1,
            },
        };
    },
    data() {
        return {
            events: [],
            groups: [],
        };
    },
};
